import { Card } from 'src/@/components/ui/card';

export default function PageContainerHeader({ titleSection, middleSection, rightSection, separatorClassName = 'hidden md:block' }) {
  return (
    <div className="sticky z-40 mb-2" style={{ overflow: 'visible' }}>
      <Card className="px-4 py-2 transition-all rounded-none" style={{ overflow: 'visible' }}>
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-2 md:gap-4 flex-1">
            {titleSection}
            <div className={`${separatorClassName} h-8 w-px bg-gray-200/60 dark:bg-[#383838]/60`} />
            {middleSection}
          </div>
          {rightSection}
        </div>
      </Card>
    </div>
  );
}